export default (params) => ({
  trigger: {
    name: 'chatbot.send_message',
    params: params,
  },
  config: {
    schema: {
      unique_id: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'chat_bar',
          'chatbot_entrance',
        ],
      },
    },
    event: {
      name: 'send',
      params: {
        content_type: 'message',
        id_type: 'conversation_id',
      },
    },
  },
});
